module.exports = __webpack_public_path__ + "img/parallaxer.adfe6298.jpeg";